<template>
  <div class="dashboard-app v2">

    <!-- user welcome -->
    <DashboardWelcome/>

    <!-- apps carousel -->
    <v-slide-group>
      <!-- back button -->
      <v-slide-item
        v-if="selectedMenu">
        <v-scale-transition>
          <DashboardCard :item="backCard"
                         @click="back"/>
        </v-scale-transition>
      </v-slide-item>
      <!-- apps -->
      <v-slide-item
        v-for="item in currentMenu"
        :key="item.id">
        <v-scale-transition>
          <DashboardCard :item="item"
                         @click="openMenu(item)"/>
        </v-scale-transition>
      </v-slide-item>
    </v-slide-group>
  </div>
</template>

<script>
  import _ from 'lodash'

  import menuMixin from '@/mixins/menu'

  import { mapGetters } from 'vuex'

  import DashboardCard from '@/components/DashboardCard'
  import DashboardWelcome from '@/components/DashboardWelcome'

   export default {
    
    name: 'Dashboard',

    mixins: [ menuMixin ],

    components:
    {
      DashboardCard,
      DashboardWelcome
    },

    data: () => ({
      page: null
    }),

    computed:
    {
      ...mapGetters({
        menu: 'menu/apps'
      }),

      slides()
      {
        const slides = _.chunk( this.menu, 12 )

        return slides
      },

      backCard()
      {
        return {
          image: '/images/arrow-left-circle.svg',
          cardCss: 'grey darken-4 white--text'
        }
      }
    },

    methods:
    {
      
    },

    load(){}
  }
</script>